import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const H1TagsKBLink = () => {
  const {
    track
  } = useTracker();
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.ADD_H1_TAGS,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsx(UILink, {
    href: "https://blog.hubspot.com/marketing/header-tags",
    external: true,
    onClick: handleClickKBLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.linkText.ADD_H1_TAGS"
    })
  });
};
export const AddH1TagsView = ({
  auditResult,
  autofixList
}) => {
  const {
    status,
    h1Elements
  } = auditResult;
  return /*#__PURE__*/_jsxs(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_H1_TAGS"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_H1_TAGS",
      options: {
        count: h1Elements ? h1Elements.length : 1
      }
    }),
    status: status,
    children: [autofixList, /*#__PURE__*/_jsx("div", {
      className: "m-left-6",
      children: /*#__PURE__*/_jsx(H1TagsKBLink, {})
    })]
  });
};